import { render, staticRenderFns } from "./CsRevisionDetalleFirmas.vue?vue&type=template&id=108794c7"
import script from "./CsRevisionDetalleFirmas.vue?vue&type=script&lang=js"
export * from "./CsRevisionDetalleFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports